export const SUPER_ADMIN = 101;
export const CREATER = 102;
export const REVIEWER = 103;
export const APPROVAL = 104;
export const LEGAL_ASSOCIATE= 105;
